/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { JSONTree } from "react-json-tree";
import { Button, Sidebar } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";

type Props = {
  value: unknown;
  label: string;
};

export function DetailPopup({ value, label }: Props) {
  const { isOpen, close, open } = useDisclosure();

  return (
    <>
      <Button icon="qa" severity="low" size="sm" onClick={open}>
        Show details
      </Button>
      <Sidebar title={label ?? ""} isOpen={isOpen} onClick={close}>
        <JSONTree
          data={value}
          theme={{
            tree: ({ style }) => ({
              style: { ...style, backgroundColor: undefined }, // removing default background color from styles
            }),
          }}
        />
      </Sidebar>
    </>
  );
}
